import React from "react";

import { Stack, Typography } from "@mui/material";

const VerticalText = ({ text }: { text: string }) => {
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0.5,
      }}
    >
      {text.split("").map((char, index) => {
        return (
          <Typography
            variant="body1"
            sx={{ color: "text.secondary", fontWeight: 900 }}
            key={index}
          >
            {char}
          </Typography>
        );
      })}
    </Stack>
  );
};

export default VerticalText;
